// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"w3-z"};